// Inline "pick one student" search box (name, roll no. or parent phone).
// Used where a form needs a single student: notifications, library issue.
import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { searchStudents } from '../api/client';
import { inputCls } from '../ui/Form';

export default function StudentPicker({ value, onChange, placeholder = 'Search student by name, roll no. or parent phone' }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);

  useEffect(() => {
    const term = q.trim();
    if (term.length < 2) { setResults([]); return; }
    const t = setTimeout(() => searchStudents(term).then(setResults).catch(() => setResults([])), 250);
    return () => clearTimeout(t);
  }, [q]);

  if (value) {
    return (
      <div className="flex items-center justify-between gap-2 border border-transit rounded-s px-3 py-2 bg-transit-tint">
        <span className="text-sm"><b className="text-ink">{value.name}</b>
          <span className="text-ink-soft"> · {value.class_name || '—'}{value.roll_number ? ` · Roll ${value.roll_number}` : ''}</span></span>
        <button type="button" onClick={() => onChange(null)} aria-label="Clear student" className="text-ink-soft hover:text-ink"><X size={15} /></button>
      </div>
    );
  }
  return (
    <div className="relative">
      <input className={`${inputCls} w-full`} value={q} onChange={e => setQ(e.target.value)} placeholder={placeholder} aria-label="Find student" />
      {results.length > 0 && (
        <div className="absolute left-0 right-0 top-full mt-1 bg-paper-raised border border-line rounded-m shadow-2 z-[1300] max-h-64 overflow-y-auto">
          {results.map(s => (
            <button type="button" key={s.id} onClick={() => { onChange(s); setQ(''); setResults([]); }}
              className="w-full text-left px-3 py-2 border-t border-line-soft first:border-t-0 hover:bg-transit-tint text-sm">
              <b className="text-ink">{s.name}</b>
              <span className="text-ink-soft"> · {s.class_name || '—'}{s.guardian_phone ? ` · ${s.guardian_phone}` : ''}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
